module.exports = __webpack_public_path__ + "static/media/HCMM571.013f9254.jpg";